const constants = {
    URL_IMAGE: process.env.REACT_APP_IMG_URL,
    URL_INSTRUCTION_MOVIE: './instruction_movie_meal.html',
    HTTP_STATUS: {
        OK: 200,
        UNAUTHORIZED: 401,
        FORBIDDEN: 403
    },
    MAX_LENGTH_DISH: 6,
    RESULT: {
        OK: 1,
        ERROR: 0
    },
    TYPE_DEFAULT: '1_4',
    AGE_DEFAULT: 15,
    ACTIVITY_DEFAULT: 2,
    CHART: {
        GROUP4: 'group4',
        GROUP6: 'group6',
        NUTRIENTS: 'nutrients',
    },
    SLIDES:{
        SHOW: 4,
        SCROLL: 1,
        RESPONSIVE_SHOW: 3,
    },
    CHOOSE_SET_MENU_SHOW_OPTION : 1,
    // cutlery
    MENU_TYPE_CUTLERY: 1,
    MENU_TYPE_CUTLERY_CARPET: 1,
    MENU_TYPE_EATING_UTENSIL: 2,
    // Dish
    MENU_TYPE_DISH: 2,
    SUB_DISH_TYPE: 3,
    DEFINE_LABELS_CHART_RADA: {
        'carbohydrate' : '炭水化物',
        'fat': '脂質',
        'protein': 'たんぱく質',
        'dietary_fiber': '食物繊維総量',
        'salt': '食塩相当量',
        'vitamin_c': 'ビタミンC',
        'vitamin_b2': 'ビタミンB2',
        'vitamin_b1': 'ビタミンB1',
        'vitamin_a': 'ビタミンA,(レチノール活性当量)',
        'iron': '鉄',
        'calcium': 'カルシウム',
        'energy': 'エネルギー',
    },
    MAX_VALUE_CHART_RADA: 120,
    SLIDES_SNACKS:{
        SHOW: 1,
        SCROLL: 1,
        ROWS: 3,
        SLIDES_PER_SHOW: 7
    },
    ORIGINAL_TYPE_DISH: 2,
    USER_SUBJECT_TYPE_DISH: 3,
    ARR_ORIGIN_LABELS_CHART: [
        'エネルギー',
        'たんぱく質',
        '脂質',
        '炭水化物',
        '食物繊維総量',
        'カルシウム',
        '鉄',
        'ビタミンA,(レチノール活性当量)',
        'ビタミンB1',
        'ビタミンB2',
        'ビタミンC',
        '食塩相当量',
    ],
    ACCEPT_FILE_UPLOAD: '.png, .gif, .jpeg, .jpg, .heic, .heif',
    KEY_BACKGROUND_MAPPING: "key_background_img",
    DEFAULT_PAGE : 1,
    ADD_DISH_INFORMATION: {
        MAXIMUM_VALUE_FOR_A_PAGE : 20,
        MAXIMUM_NUMBER_OF_INGREDIENTS_TABLE: 30,
        MINIMUM_NUMBER_OF_INGREDIENTS_TABLE: 6,
        DEFAULT_PAGE : 1,
        DEFAULT_NUM_PEOPLE : 1,
    },
    FOOD_SEARCH: {
        NUMBER_OF_PAGINATION: 10,
        DEFAULT_NUMBER_OF_PAGINATION: 1
    },
    NORMAL_DISH: 1,
    ORIGINAL_DISH: 2,
    ORIGINAL_DISH_PAGINATION:{
        NUMBER_OF_PAGINATION: 10,
        DEFAULT_NUMBER_OF_PAGINATION: 1,
        SECOND_NUMBER_OF_PAGINATION: 2
    },
    DISH_INGREDIENT: {
        CONTAIN_A_LOT: {
            "protein.many" : "たんぱく質を多く含む",
            "carbohydrate.many" : "炭水化物を多く含む",
            "calcium.many" : "カルシウムを多く含む",
            "iron.many" : "鉄を多く含む",
            "vitamin_a.many" : "ビタミンAを多く含む",
            "vitamin_b1.many" : "ビタミン<t class='font-georgia'>B1</t>を多く含む",
            "vitamin_b2.many" : "ビタミン<t class='font-georgia'>B2</t>を多く含む",
            "vitamin_c.many" : "ビタミンCを多く含む",
            "dietary_fiber.many" : "食物繊維を多く含む",
        },
        CONTAIN_LITTLE: {
            "salt.few" : "食塩（相当量）が少ない",
            "fat.few" : "脂質が少ない",
        }
    },
    DISH_INGREDIENT_OTHER: {
        CONTAIN_A_LOT: {
            "protein.many" : "たんぱく質を多く含む",
            "carbohydrate.many" : "炭水化物を多く含む",
            "calcium.many" : "カルシウムを多く含む",
            "iron.many" : "鉄を多く含む",
            "vitamin_a.many" : "ビタミンAを多く含む",
            "vitamin_b1.many" : "ビタミンB1を多く含む",
            "vitamin_b2.many" : "ビタミンB2を多く含む",
            "vitamin_c.many" : "ビタミンCを多く含む",
            "dietary_fiber.many" : "食物繊維を多く含む",
        },
        CONTAIN_LITTLE: {
            "salt.few" : "食塩（相当量）が少ない",
            "fat.few" : "脂質が少ない",
        }
    },
    DISH_GROUP_6: {
        1 : "第１群：魚・肉・卵・大豆・大豆製品",
        2 : "第２群：牛乳・乳製品・海藻・小魚類",
        3 : "第３群：緑黄色野菜",
        4 : "第４群：その他の野菜・果物",
        5 : "第５群：穀類・いも類・砂糖",
        6 : "第６群：油脂"
    },
    DISH_GROUP_4: {
        1 : "第１群：乳製品・卵",
        2 : "第２群：魚介・肉・豆・豆製品",
        3 : "第３群：野菜(きのこ・海藻を含む)・芋・果物",
        4 : "第４群：穀類・種実・油脂・砂糖",
    },
    CATEGORY_KEY: {
        STAPLE_FOOD: {
            KEY: "staple_food",
            RICE:{
                KEY: "staple_food.rice",
                NAME: "ごはん",
                ICON: "./img/icon/staple_food-rice.png"
            },
            BREAD: {
                KEY: "staple_food.bread",
                NAME: "パン・その他",
                ICON: "./img/icon/staple_food-bread.png"
            },
            NOODLES: {
                KEY: "staple_food.noodles",
                NAME: "麺",
                ICON: "./img/icon/staple_food-noodles.png"
            },
        },
        MAIN_DISH: {
            KEY: "main_dish",
            MEAT: {
                KEY: "main_dish.meat",
                NAME: "肉料理",
                ICON: "./img/icon/main_dish-meat.png"
            },
            FISH:{
                KEY: "main_dish.fish",
                NAME: "魚料理",
                ICON: "./img/icon/main_dish-fish.png"
            },
            EGG: {
                KEY: "main_dish.egg",
                NAME: "卵料理",
                ICON: "./img/icon/main_dish-egg.png"
            },
            BEANS: {
                KEY: "main_dish.beans",
                NAME: "豆・豆製品",
                ICON: "./img/icon/main_dish-beans.png"
            },
        },
        SIDE_DISH: {
            KEY: "side_dish",
            POTATO:{
                KEY: "side_dish.potato",
                NAME: "いも",
                ICON: "./img/icon/side_dish-potato.png"
            },
            VEGETABLE: {
                KEY: "side_dish.vegetable",
                NAME: "野菜・きのこ・海藻",
                ICON: "./img/icon/side_dish-vegetable.png"
            },
        },
        SOUP_DRINK: {
            KEY: "soup_drink",
            SOUP:{
                KEY: "soup_drink.soup",
                NAME: "汁物",
                ICON: "./img/icon/soup_drink-soup.png"
            },
            DRINK: {
                KEY: "soup_drink.drink",
                NAME: "飲み物",
                ICON: "./img/icon/soup_drink-drink.png"
            },
        },
        DESSERT: {
            KEY: "dessert",
            DESSERT:{
                KEY: "dessert.dessert",
                NAME: "デザート",
                ICON: "./img/icon/dessert-dessert.png"
            },
            FRUIT: {
                KEY: "dessert.fruit",
                NAME: "果物",
                ICON: "./img/icon/dessert-fruit.png"
            },
        },
        SNACK: {
            KEY: "snack",
            OYATSU:{
                KEY: "snack.oyatsu",
                NAME: "おやつ"
            },
            FRUIT: {
                KEY: "snack.fruit",
                NAME: "くだもの"
            },
            DRINK: {
                KEY: "snack.drink",
                NAME: "飲み物"
            },
        },
        ALL: {
            KEY: "all",
            NAME: "すべて",
            ICON: ""
        }
    },
    CLASSIFICATION_SHEET: {
        GRID: 8,
        NUM_ITEMS: 5,
        COLUMNS: {
            SINGLE: 1,
            DOUBLE: 2,
            TRIPPLE: 3,
        },
        TYPE_SHEET:{
            FOUR_FOOD: 0,
            SIX_FOOD: 1,
            NUTRIENTS: 2,
        },
    },
    VIEW_MODE_GRAPH: {
        A_MEAL: 1,
        THREE_MEAL: 2
    },
    GRAPH_TYPE: {
        GROUP4: "group4",
        GROUP6: "group6",
        NUTRIENTS: "nutrients"
    },
    SELF_ASSESSMENT_TYPE: {
        CAN_DO: 1,
        TEMPORARY: 2,
        CAN_NOT_DO: 3
    },
    LIST_ORIGINAL_DISH: {
        MIN_INDEX_NO: 1,
        MAX_INDEX_NO: 10
    },
    DEFAULT_CARPET_ID: 21,
    TIME: {
        SESSION: 120,
        SESSION_TIME_OUT: 10
    },
    PERSON_INFO_DEFAULT: {
        AGE: 15,
        FACE_ICON_TYPE: '1_1',
        SEX_TYPE: 1
    },
    OS_OF_IOS_DEVICES: ["iOS", "Mac OS"],
    OS_OF_CHROMEOS_DEVICES: ["Chrome OS"],
    MAPPING_TYPE_SHEET: {
        g4: 'group4',
        g6: 'group6',
        nutrients: 'nutrients'
    },
    DEFAULT_ORIGINAL_DISH_Z_INDEX: 1,
    DEFAULT_DISH_SIZE_TYPE: 2,
    ISCAPTURE: "capture",
    BEFORE_TIME_OUT : 10,
    IS_AUTO_SAVE : 1,
    NOT_AUTO_SAVE : 0,
    TITLE_TAB: {
        LOGIN: "ログイン｜ミルミル献立計画",
        REGISTRATION_NAME: "氏名登録｜ミルミル献立計画",
        EDIT_NAME: "氏名編集｜ミルミル献立計画",
        TITLE: "タイトル｜ミルミル献立計画",
        CLASSIFI_SHEET_DEFAULT: "基本分類シート｜ミルミル献立計画",
        CONDITION_SETTING: "人物設定｜ミルミル献立計画",
        MENU_TABLE: "献立表｜ミルミル献立計画",
        CHOOSE_DISH: "料理選択｜ミルミル献立計画",
        CLASSIFI_SHEET: "分類シート｜ミルミル献立計画",
        NUTRIENTS_GRAPH: "各種グラフ・表｜ミルミル献立計画",
        CONTINUE: "続きから作る｜ミルミル献立計画",
        CHOICE_TASK: "課題から作る｜ミルミル献立計画",
        DELETE: "保存データ削除｜ミルミル献立計画",
        ERROR: "エラー｜ミルミル献立計画",
        ERROR_OUT_TIME: "操作時間外｜ミルミル献立計画"
    },
    NUTRIENTS_DISPLAY: {
        ENERGY: {
            UNIT_DATA: "kcal"
        },
        PROTEIN: {
            UNIT_DATA: "g"
        },
        FAT: {
            UNIT_DATA: "g"
        },
        CARBOHYDRATE: {
            UNIT_DATA: "g"
        },
        CALCIUM: {
            UNIT_DATA: "mg"
        },
        IRON: {
            UNIT_DATA: "mg"
        },
        VITAMIN_A: {
            UNIT_DATA: "µg"
        },
        VITAMIN_B1: {
            UNIT_DATA: "mg"
        },
        VITAMIN_B2: {
            UNIT_DATA: "mg"
        },
        VITAMIN_C: {
            UNIT_DATA: "mg"
        },
        DIETARY_FIBER: {
            UNIT_DATA: "g"
        },
        SALT: {
            UNIT_DATA: "g"
        },
        POTASSIUM: {
            VALUE: "potassium",
            DISPLAY: "カリウム",
            UNIT_DATA: "mg"
        },
        MAGNESIUM: {
            VALUE: "magnesium",
            DISPLAY: "マグネシウム",
            UNIT_DATA: "mg"
        },
        PHOSPHORUS: {
            VALUE: "phosphorus",
            DISPLAY: "リン",
            UNIT_DATA: "mg"
        },
        ZINC: {
            VALUE: "zinc",
            DISPLAY: "亜鉛",
            UNIT_DATA: "mg"
        },
        COPPER: {
            VALUE: "copper",
            DISPLAY: "銅",
            UNIT_DATA: "mg"
        },
        MANGANESE: {
            VALUE: "manganese",
            DISPLAY: "マンガン",
            UNIT_DATA: "mg"
        },
        IODINE: {
            VALUE: "iodine",
            DISPLAY: "ヨウ素",
            UNIT_DATA: "µg"
        },
        SELENIUM: {
            VALUE: "selenium",
            DISPLAY: "セレン",
            UNIT_DATA: "µg"
        },
        CHROMIUM: {
            VALUE: "chromium",
            DISPLAY: "クロム",
            UNIT_DATA: "µg"
        },
        MOLYBDENUM: {
            VALUE: "molybdenum",
            DISPLAY: "モリブデン",
            UNIT_DATA: "µg"
        },
        VITAMIN_E: {
            VALUE: "vitamin_e",
            DISPLAY: "ビタミンE\n(α-トコフェロール）",
            UNIT_DATA: "mg"
        },
        NIACIN: {
            VALUE: "niacin",
            DISPLAY: "ナイアシン",
            UNIT_DATA: "mg"
        },
        VITAMIN_B6: {
            VALUE: "vitamin_b6",
            UNIT_DATA: "mg"
        },
        VITAMIN_B12: {
            VALUE: "vitamin_b12",
            UNIT_DATA: "µg"
        },
        FOLIC_ACID: {
            VALUE: "folic_acid",
            DISPLAY: "葉酸",
            UNIT_DATA: "µg"
        },
    },
    CHOPSTICKS: [21, 22, 23, 24, 25, 26],
    VESSEL_SIZE: {
        1: "./img/type_plate/d1.png",
        2: "./img/type_plate/d2.png",
        3: "./img/type_plate/d3.png",
        4: "./img/type_plate/d4.png",
        5: "./img/type_plate/d5.png",
    },
    TRIMMING_SIZE_UNIT: 43.5,
    SESSION_TYPE: {
        DEFAULT : 0,
        LOCAL : 1,
        API : 2,
    },

    // automatic scoring
    BOX_STATUS:{
        STATUS_NOT_EVALUATED: 1,
        STATUS_DB_EVALUATING: 2,
        STATUS_EVALUATED: 3
    },

    MEAL_NUM_TYPE: {
        ONE_MEAL: 1,
        ONE_DAY: 3
    },

    REL_DISH_TYPE: {
        USER_SUBMIT_DISH: 2,
        SUBJECT_DISH: 3
    },

    MENU_TABLE_TAB: {
        LIST: 1,
        GROUP4: 2,
        GROUP6: 3,
        NUTRIENTS: 4,
    },
    MAX_LENGTH_DISH_CAPTURE: {
        DISH: 16,
        DISH_ORIGINAL: 18,
        SNACK: 9
    }
}
export default constants;